import {get} from 'lodash';

export default (state = {}, {coachId, data}: any) => {
  return {
    ...state,
    allProfiles: {
      ...get(state, 'allProfiles', {}),
      [coachId]: data,
    },
  };
};
